import { render, staticRenderFns } from "./EndorsementHistoryTable.vue?vue&type=template&id=1f246aa4&scoped=true&"
import script from "./EndorsementHistoryTable.vue?vue&type=script&lang=js&"
export * from "./EndorsementHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementHistoryTable.vue?vue&type=style&index=0&id=1f246aa4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f246aa4",
  null
  
)

export default component.exports